export const formatInternationalizedContent = (content: any, language: string) => {
  if (!content) return content;

  if (content.asset && content.asset._type === 'sanity.imageAsset') {
    return {
      ...content,
      asset: {
        ...content.asset,
        metadata: content.asset.metadata || {},
        altText: content.asset.altText || content.alt || '',
        title: content.asset.title || '',
        description: content.asset.description || '',
      },
    };
  }

  if (typeof content === 'string') return content;

  if (content._type === 'localeString') {
    const keys = Object.keys(content).filter((key) => key !== '_type');
    const key = keys.find((key) => language.startsWith(key)) || 'en';
    return content[key] ?? content.fr;
  }

  // localeString sans _type (objet { fr, en, de })
  // Les valeurs doivent être des strings : sinon on écraserait des objets légitimement
  // indexés par langue (ex. componentStates.customData = { fr: {...}, en: {...} }).
  if (
    typeof content === 'object' &&
    !Array.isArray(content) &&
    !content._type &&
    ('fr' in content || 'en' in content || 'de' in content) &&
    Object.keys(content).every((k) => ['fr', 'en', 'de', '_type', '_key'].includes(k)) &&
    Object.entries(content).every(
      ([k, v]) => k.startsWith('_') || v == null || typeof v === 'string'
    )
  ) {
    const lang = language.slice(0, 2);
    return content[lang] ?? content.fr ?? content.en ?? '';
  }

  if (Array.isArray(content) && content[0]?._type === 'internationalizedArrayStringValue') {
    const localizedText =
      content.find((text) => language.startsWith(text._key)) ||
      content.find((text) => text._key === 'en') ||
      content.find((text) => !!text);
    return localizedText ? localizedText.value : '';
  }

  if (Array.isArray(content)) {
    return content.map((c) => formatInternationalizedContent(c, language));
  }

  if (typeof content === 'object') {
    const result = {};

    for (const key in content) {
      if (content.hasOwnProperty(key)) {
        result[key] = formatInternationalizedContent(content[key], language);
      }
    }

    return result;
  }

  return content;
};

export default formatInternationalizedContent;
